module.exports = __webpack_public_path__ + "img/center.af22c2b6.png";